import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

interface Route {
    title : string
    path : string
}

function Banner({data}) {
    const { t } = useTranslation();

    function showBreadCrumb(route:Route, index:number) {
        if(index===data.navigation.length-1)
            return <li key={index}><span>{route.title}</span></li>
        else
            return <li key={index}><Link to={route.path}>{route.title}</Link></li>
    }
    
    return(
        <section className="knsl-banner-simple knsl-transition-bottom">
            <img src="assets/img/palm.svg" className="knsl-deco-left" alt="palm" />
            <img src="assets/img/palm.svg" className="knsl-deco-right" alt="palm" />
            <div className="container">
                <div className="row">
                <div className="col-lg-12">

                    <div className="knsl-center knsl-title-frame">
                    <h1 className="knsl-mb-20 knsl-h1-inner">{data.title}</h1>
                    <p className="knsl-mb-30">{data.description}</p>
                    <ul className="knsl-breadcrumbs">
                        <li><Link to="/">{t('main.home')}</Link></li>
                        {data.navigation.map((route:Route,index) => showBreadCrumb(route,index))}
                    </ul>
                    </div>

                </div>
                </div>
            </div>
        </section>
    )
}

export default Banner